/**
 * Quote Carousel Block
 */
import Swiper from "swiper";
import { A11y, Keyboard, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".quote-carousel");

  carousels.forEach((carousel) => {
    initializeQuoteCarousel(carousel);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".quote-carousel")) {
    initializeQuoteCarousel(block);
  }

  block.querySelectorAll(".quote-carousel").forEach((carousel) => {
    initializeQuoteCarousel(carousel);
  });
});

function initializeQuoteCarousel(carouselElement) {
  const swiperContainer = carouselElement.querySelector(".quote-carousel__swiper");
  const paginationElement = carouselElement.querySelector(
    ".quote-carousel__pagination",
  );

  if (
    !swiperContainer ||
    swiperContainer.dataset.quoteCarouselInitialized === "true"
  ) {
    return;
  }

  const slides = swiperContainer.querySelectorAll(".swiper-slide");

  swiperContainer.dataset.quoteCarouselInitialized = "true";

  if (slides.length < 2) {
    carouselElement.classList.add("quote-carousel--locked");
    return;
  }

  const syncLockState = (swiperInstance) => {
    carouselElement.classList.toggle(
      "quote-carousel--locked",
      swiperInstance.isLocked,
    );
  };

  new Swiper(swiperContainer, {
    modules: [A11y, Keyboard, Pagination],
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 700,
    // No `autoHeight`: it pins an inline height on the wrapper that goes stale
    // when the quote reflows on resize, clipping the text. The track sizes to
    // the tallest slide via flex instead.
    watchOverflow: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    allowTouchMove: slides.length > 1,
    keyboard: {
      enabled: slides.length > 1,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: "Previous quote",
      nextSlideMessage: "Next quote",
      paginationBulletMessage: "Go to quote {{index}}",
    },
    pagination: paginationElement
      ? {
          el: paginationElement,
          clickable: true,
          renderBullet(index, className) {
            return `<button class="${className} quote-carousel__pagination-bullet" type="button" aria-label="Go to quote ${index + 1}"></button>`;
          },
        }
      : false,
    on: {
      init() {
        syncLockState(this);
      },
      resize() {
        syncLockState(this);
      },
      lock() {
        syncLockState(this);
      },
      unlock() {
        syncLockState(this);
      },
    },
  });
}
